import React from 'react';
import {Routes, Route} from 'react-router-dom';
import AuthRoutes from '@contentlab/routes/auth';
import mainRoutesList, {MainRoute} from '../mainRoutesList';

export type MainRoutesProps = {
  flags: any;
};

function MainRoutes(props: MainRoutesProps) {
  const {flags} = props;

  return (
    <Routes>
      {AuthRoutes()}
      {mainRoutesList.map(({path, Component, name}: MainRoute) => (
        <Route key={name} path={path} element={<Component flags={flags} />} />
      ))}
    </Routes>
  );
}

export default MainRoutes;
